(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('EvaluationDietsHistoryController', EvaluationDietsHistoryController);

    EvaluationDietsHistoryController.$inject = ['$uibModalInstance', 'Diet', 'chart'];

    function EvaluationDietsHistoryController($uibModalInstance, Diet, chart) {
        var vm = this;

        vm.dietsInactive = [];
        vm.dietsInactive = Diet.findAllByChart({chartId: chart.id, page: 0, size: 100});

        vm.clear = clear;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
